var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgIcon3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "#437EF7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 20C34.9455 20 37.3333 17.6122 37.3333 14.6666C37.3333 11.7211 34.9455 9.33331 32 9.33331C29.0544 9.33331 26.6666 11.7211 26.6666 14.6666C26.6666 15.1696 26.7362 15.6563 26.8664 16.1176L19.7887 20.2463C18.8222 19.2708 17.4816 18.6666 16 18.6666C13.0544 18.6666 10.6666 21.0545 10.6666 24C10.6666 26.9455 13.0544 29.3333 16 29.3333C17.4816 29.3333 18.8222 28.7291 19.7887 27.7537L26.8664 31.8823C26.7362 32.3437 26.6666 32.8304 26.6666 33.3333C26.6666 36.2788 29.0544 38.6666 32 38.6666C34.9455 38.6666 37.3333 36.2788 37.3333 33.3333C37.3333 30.3878 34.9455 28 32 28C30.5183 28 29.1777 28.6042 28.2113 29.5796L21.1335 25.451C21.2637 24.9896 21.3333 24.5029 21.3333 24C21.3333 23.497 21.2637 23.0103 21.1335 22.549L28.2113 18.4203C29.1777 19.3958 30.5183 20 32 20Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon3);
export default __webpack_public_path__ + "static/media/icon3.e78ea3d63f32325f0e2083d3f276c4c5.svg";
export { ForwardRef as ReactComponent };